import React from 'react';
import { ArrowRight } from 'lucide-react';
interface CtaButtonProps {
  text: string;
  className?: string;
  variant?: 'primary' | 'secondary';
  size?: 'md' | 'lg' | 'xl';
}
export function CtaButton({
  text,
  className = '',
  variant = 'primary',
  size = 'lg'
}: CtaButtonProps) {
  const sizeClasses = {
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg md:text-xl',
    xl: 'px-10 py-5 text-xl md:text-2xl'
  };
  const variantClasses = {
    primary: 'bg-brand-yellow text-brand-purpleDark hover:bg-[#E5B515] shadow-[0_8px_20px_rgba(245,197,24,0.3)]',
    secondary: 'bg-brand-purple text-white hover:bg-[#5A358A] shadow-[0_8px_20px_rgba(107,63,160,0.3)]'
  };
  const handleClick = () => {
    if (typeof window !== 'undefined' && (window as any).fbq) {
      ;
      (window as any).fbq('track', 'AddToCart');
    }
  };
  return <a href="https://www.mareaa.online/cart/53237108638061:1" onClick={handleClick} className={`
        inline-flex items-center justify-center gap-2 
        font-sans font-bold rounded-xl
        transition-all duration-300 transform hover:-translate-y-1 hover:shadow-lg
        text-center w-full sm:w-auto
        ${sizeClasses[size]}
        ${variantClasses[variant]}
        ${className}
      `} data-id="element-52">
      <span data-id="element-53">{text}</span>
    </a>;
}